<template>
    <div class="netflix-header">

<div class="nav">

    <ul>
        <li class="logo"><img src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2F1000logos.net%2Fwp-content%2Fuploads%2F2017%2F05%2FNetflix-Logo.png&f=1&nofb=1" alt="logo"></li>
        <li>Home</li>
        <li>Tv Shows</li>
        <li>Movies</li>
        <li>New & Popular</li>
        <li>My List</li>
    </ul>
</div>

<div class="icons">
    <img src="../assets/search-solid.svg" alt="searchicon" class="searchicon">
    <img src="../assets/bell-solid.svg" alt="bell" class="bellicon">
<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAC01BMVEXmsgnmswnmsgrmsgfmsxjmtCPmsxHmswfmsxDmsyPmsxnmswrmsgLmsx3msQDlrQDmsg/msxXmsgTmsgXmsxPmshPlrgDmsx7mswLmsxvouUbsyILmsgDmsgjmsxTsx4Dou07mswXmsxzmsADpvmH9+PH////47Nnmsw/36dP9+vXqwWzlrwDntB7mtAvmswvntS3kqwDz3LX9+/jsxnvmtCLmsgvmtB/++/n04MDkqgDntS7mtA3syH/89u3nuDnmswDmtBjmsw3mtBbntSX79Ojty4rntBDntA7ntSDsx33y2rDqvVbntA/ntRDntQ7ntR7pvE7y2q/tyYLntQ/ntRPntiLnswDnth/nthPntADntiHnthbnthXouCjouTHntyHnthTnthfntxbntyDouDDnuC3ntxnntxXotxnouBnotxjouCnouTDouSfotxrouCHotg7otwzouBvouBjouB3ouBzouR3ouCDntQDouSjpujPpuzLouS/oui7pujDpujHouAPouSHpuzDouBTouiDouiHouSDpui7148L36M7rxGLntgDpvDXy2arz26/puzTpuyXpuiTpvDHotwDz267///389+7358vy2qrw0pTv0Izw1Jr03bX57tv///736M3rwlbpuhXpuyvpvCnpvSnpvCjpvTDpvSf469T9+fL+/vv79Of037frxFvpugTpvC7qvS3qvi3qvi7qvS7qvSzqvzrqvSnotgDpugDrwUjtxmbtx23sxV7qvzPouADpuwfqvz3qvjLqvzHqvzLqvjHqvzXqwD7qwEDqvzbqvSLpvATpuwDpvBDqvivqwDzqvzjrwDXqwDTrwDbrwDnrwTvrwTzrwDjrwTXrwTnrwjnrwz3rwj3rwz7sxEHsxUXsxEXsxETsxkjsxUjsxkntx0ztx0vtyE7tx07tx03tyE/tyFDtyVDtyVHtyVPtyVLtylMYBqiaAAACg0lEQVQ4y2NgYGBgZAQRIArEYICSCMCIEIIyGWG6kNQzQoSQNTMyoihjhIuhmA1Xx8jIiGw7IzY2I7oMxOFAkomZhZWNmQlZCxM7BycXOxOEz83Dy8cvICjEBPMmkBIWERXjE5dgAhnCICwpJiUtwyfIDOaBFcnK8cnIK4hJKoLVKymrqKqpy7Cxwf3DqMHCp6mmpa2jC+Tr6RsYGqkZq5mImeoDgRkYmetoq1moWVpZ6+sz2Niw6tiqqdnZOzg62dgAEQg4K7q4qqm56bg42TC4u3t4Knt5+/B5eri7+7r7+fm5u/v5B/AFBgUrB4S4+zGEhob6h/Hxh0d4hEaGQhFQKCKKny86BMhiiAGC2Lj4hMQkECs5BgySkxJTUtPSM4B8hkwgyMqEgOyc3Lx8KLsgvrCouCQzk6G0rLSsrLS0vLysrLginK+yqrqmtq6+uqGRr6m5BSjM0NrW1tre2tre1t7UUdnZ1d0jEx5VGeXg0Nun1u8woa2dYSIQTJoIBpOnTJ2mNn3GzFmz58ydN19twcJFiydOZFgCAUuBeNnynhVzVq6ar6amtnrN2nWV6zcsW7KUYSMQbNq4cTMQbdm6bfuUHTt37d6zd9/+KQcOHtoKFGQ4fOQwEBw9DAHHjp84eer0mbPnzp+4ABY7wnARDC5dvAhjXL5y9drV65eh/BsMN/GAW0DMcBsI7ty5c/sulAYSYCaUc5vhHgHAcB8CHtxHBw8fgoj7DI8ePQaiJ4+g4AkEgxBEjOHps6fPnj0FASgFZCBTDM9fPH/58vkrIAVCz4EcEPUSJAgCLxhev37zBozfvAViEOMtiPMGLAoUYnj3/sN7KHgHIWAiQBooAgDOvMjSUk2HRwAAAABJRU5ErkJggg==" alt="user" class="user">
</div>
</div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.scroll-active{
      background-color: black;
      color:white;
  }
   .netflix-header{
    position: fixed;
    width:100%;
    display: flex;
    height: 5vw;
    justify-content: space-between;
    align-items: center;
    top:0;
    left:0;
    z-index: 6000;
    color:white;
    box-sizing: border-box;
    padding-right: 4vw;
    transition: 0.4s all linear;
    background-image: linear-gradient(to bottom,rgba(0,0,0,.7) 10%,rgba(0,0,0,0));
}
.logo{
    width:6vw;
    height:3vw;
    overflow: hidden;
    display: inline-block;
}
.logo img{
  width:100%;
  height: 100%;
  object-position: center;
  object-fit: cover;
}

.nav ul{
    display: flex;
    align-items: center;
    list-style-type: none;
}
.nav ul li{
    margin-left: 2vw;
    font-size: 1vw;
}
.icons{
   
    display: flex;
    flex-direction: row;
    align-items: center;
}
.searchicon, .bellicon{
    height:1.5vw;
    width: 1.5vw;
    margin-right:2vw;
}
</style>